/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IAny, IGeneric, IVideoData } from '../../interfaces';
import { IEditableFieldProps } from './editable-field';
import { getEditableFieldClassName } from './utils';

export const VideoField = (props: IEditableFieldProps<IGeneric<IAny> & { children?: JSX.Element }>) => {
    const onKeyPress = (event: React.KeyboardEvent<HTMLImageElement>) => {
        // 'enter' key
        if (event.charCode === 13 && props.onChange) {
            event.preventDefault();
            props.onChange(event);
        }
    };
    const editableProps = props.disabled
        ? {}
        : {
              onKeyPress: onKeyPress,
              onDoubleClick: props.onChange,
              onMouseOver: props.onMouseOver,
              onFocus: props.onFocus,
              onBlur: props.onBlur,
              onMouseOut: props.onMouseOut,
              tabIndex: 0
          };

    const key = (props.editPropKey as IVideoData)?.id;

    return (
        <div
            key={key}
            {...editableProps}
            role={props.fieldProps.role || 'presentation'}
            className={getEditableFieldClassName(props.disabled, props.fieldProps.className, props.requestContext)}
        >
            {props.fieldProps.children}
        </div>
    );
};
